// deps
import React, { memo } from "react";

// styled
import { IconWrapper, PointComponentWrapper, PointText, PointWrapper, Title } from "./styled";

// SVG
import QRCodeSvg from "./assets/QRCodeSvgIcon";
import BookedDateTimeSvg from "./assets/BookedDateTimeSvg";
import CreditScoreSvg from "./assets/CreditScore";

// constants
import { WHAT_TO_DO_NEXT_DATA } from "@dineout-payment-success-ui/constants";

export interface WhatToDoNextProps {
    isPartialPayment: boolean;
}

export const POINTS_DATA_FULL_PAYMENT = [
    { icon: <BookedDateTimeSvg />, text: WHAT_TO_DO_NEXT_DATA.Points.FullPayment.One },
    { icon: <QRCodeSvg />, text: WHAT_TO_DO_NEXT_DATA.Points.FullPayment.Two },
];

export const POINTS_DATA_PARTIAL_PAYMENT = [
    { icon: <CreditScoreSvg />, text: WHAT_TO_DO_NEXT_DATA.Points.PartialPayment.One },
];

const WhatToDoNext: React.FC<WhatToDoNextProps> = ({ isPartialPayment }) => {
    const POINTS_DATA = isPartialPayment ? POINTS_DATA_PARTIAL_PAYMENT : POINTS_DATA_FULL_PAYMENT;
    return (
        <div>
            <Title variant="V2.body1.neutral.bold">{WHAT_TO_DO_NEXT_DATA.Title}</Title>
            <PointWrapper>
                {POINTS_DATA.map((point, index) => (
                    <PointComponentWrapper key={index}>
                        <IconWrapper>{point.icon}</IconWrapper>
                        <PointText variant="V2.body3.neutral.regular">{point.text}</PointText>
                    </PointComponentWrapper>
                ))}
            </PointWrapper>
        </div>
    );
};

export default memo(WhatToDoNext);
